module.exports = __webpack_public_path__ + "img/coin_3.76d86d64.png";